export default __webpack_public_path__ + "static/subset-UniNeueLight-e5414886acfb987e6bd6283bab430acb.woff";